import React from "react";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";

function WhoWeAre() {
    return (
        <div className="landing-page-component">
            <FrontHeader />
            <div className="page-content pb-5">
                <div className="container-easy-market">
                    <div className="container">
                        {/* Titre principal */}
                        <h1 className="about-us-main-title">
                            Qui sommes-nous ?
                        </h1>

                        {/* Première section : Image + Texte */}
                        <div className="about-us-section">
                            <div className="row align-items-center">
                                {/* Image à gauche */}
                                <div className="col-md-6 col-lg-5">
                                    <div className="about-us-image-container">
                                        <img 
                                            src="/lacachotiere Contact.png" 
                                            alt="LA CACHOTIÈRE - Qui sommes-nous"
                                            className="about-us-image"
                                        />
                                    </div>
                                </div>

                                {/* Texte à droite */}
                                <div className="col-md-6 col-lg-7">
                                    <div className="about-us-content">
                                        <p className="about-us-subtitle">
                                            QUI SOMMES-NOUS
                                        </p>
                                        <h2 className="about-us-brand-name">
                                            LA CACHOTIÈRE
                                        </h2>
                                        <div className="about-us-description">
                                            <p>
                                                La Cachotière est une marque 100% made in Sénégal,
                                                créée par des femmes et pour des femmes.
                                            </p>
                                            <p>
                                                Elle réunit deux univers complémentaires – la lingerie et
                                                la parfumerie – pour offrir à chaque femme une
                                                expérience unique, mêlant sensualité, élégance et
                                                confiance en soi.
                                            </p>
                                            <p>
                                                Notre promesse : célébrer la féminité à travers des
                                                créations locales de qualité, tout en valorisant le savoir-
                                                faire sénégalais.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section Vision */}
                        <div className="about-us-values-section">
                            <h3 className="about-us-values-title">
                                Vision
                            </h3>
                            <p className="about-us-description">
                                Devenir la première maison de lingerie et de parfumerie africaine qui rayonne au Sénégal et à l'international, en portant haut les couleurs du "Made in Sénégal".
                            </p>
                        </div>

                        {/* Section Mission */}
                        <div className="about-us-values-section">
                            <h3 className="about-us-values-title">
                                Mission
                            </h3>
                            <ul className="about-us-values-bullets">
                                <li>
                                    Créer une lingerie raffinée et confortable, adaptée à toutes les morphologies.
                                </li>
                                <li>
                                    Offrir des parfums authentiques inspirés des richesses naturelles et culturelles du Sénégal.
                                </li>
                                <li>
                                    Soutenir l'artisanat local et promouvoir l'autonomisation économique des femmes.
                                </li>
                                <li>
                                    Redéfinir la sensualité africaine à travers des produits modernes, élégants et 100% locaux.
                                </li>
                            </ul>
                        </div>

                        {/* Section Valeur */}
                        <div className="about-us-values-section">
                            <h3 className="about-us-values-title">
                                Valeur
                            </h3>
                            <ul className="about-us-values-bullets">
                                <li>
                                    <strong>Féminité</strong> : célébrer toutes les femmes, dans leur diversité et leur unicité.
                                </li>
                                <li>
                                    <strong>Authenticité</strong> : puiser dans les racines et les senteurs locales.
                                </li>
                                <li>
                                    <strong>Élégance</strong> : proposer des créations modernes et raffinées.
                                </li>
                                <li>
                                    <strong>Engagement</strong> : soutenir l'emploi féminin et la production locale.
                                </li>
                                <li>
                                    <strong>Durabilité</strong> : privilégier des matières et packagings responsables.
                                </li>
                            </ul>
                        </div>

                        {/* Section Mot de la fondatrice */}
                        <div className="about-us-founder-section">
                            <div className="about-us-founder-header">
                                <p className="about-us-founder-subtitle">
                                    QUI SOMMES-NOUS
                                </p>
                                <h3 className="about-us-founder-title">
                                    Mot de la fondatrice
                                </h3>
                            </div>
                            <div className="about-us-founder-quote-card">
                                <div className="about-us-founder-quote">
                                    <p>
                                        La Cachotière est née d'une histoire intime et profonde, celle de ma mère. Femme passionnée et talentueuse, elle excellait dans la couture sous toutes ses formes : broderie à la main et à la machine, création de bijoux, confection de sacs à main en perles et en tissu. Mais au-delà de son savoir-faire, ce qui me marquait le plus était sa générosité : elle formait d'autres femmes, leur offrant une chance d'apprendre un métier et de bâtir leur indépendance.
                                    </p>
                                    <p>
                                        Aujourd'hui, je souhaite perpétuer son héritage et faire vivre cette passion qui m'anime à mon tour. C'est ainsi qu'est née La Cachotière, une maison dédiée à la lingerie et à la parfumerie, deux univers qui célèbrent la féminité, l'élégance et la confiance en soi.
                                    </p>
                                    <p>
                                        À travers chaque pièce et chaque fragrance, je rends hommage à ma mère, à son talent et à son esprit de transmission. La Cachotière, c'est l'histoire d'un héritage qui devient un rêve accompli.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FrontFooter />
        </div>
    );
}

export default WhoWeAre;
